var exports = {
  "S": "x28a7bf27--b67df7--fin-container",
};

module.exports = exports;
